import Logo from '#assets/svg/logo.svg';

const LandingFooter = () => {
  return (
    <div className="bg-[#1F1E25] px-32 py-40 flex flex-col items-start gap-32 w-full">
      <img src={Logo} width={70} height={22} />

      <div className="leading-20 text-[#7B818F] text-[14px] pt-14 border-t-1 border-solid border-[#34363E] w-full">
        <p>대표이사 송채겸 | 사업자등록번호 813-81-03095</p>
        <p>통신판매업신고번호 2024-성남수정-0053호</p>
        <p>전화번호 0504-0819-8438</p>
        <p>
          경기도 성남시 수정구 성남대로 1342, 지하1층 B101호 공과대학1 내
          가천스타트업팩토리(복정동, 가천대학교)
        </p>
      </div>
    </div>
  );
};

export default LandingFooter;
